export const EXCEPTION_MESSAGES = {
  API_ERROR: 'API 에러',
  RUNTIME_ERROR: 'Runtime 에러',
  CHIME_ERROR: 'Chime 에러',
  AUDIO_INPUT_ERROR: 'Audio Input 에러',
  VIDEO_INPUT_ERROR: 'Video Input 에러',
  MEETING_START_ERROR: 'Meeting Start 에러',
  MEETING_ERROR: 'Meeting 에러',
  MEETING_SESSION_ERROR: 'Meeting Session 에러',
};
